import traceUFOPress from '@atlaskit/react-ufo/trace-press';
import { getNormalisedPerformanceFFs } from '@atlassian/jira-common-long-task-metrics/src/common/util/collectors';
import { scheduleAfterRender } from '@atlassian/jira-software-react-scheduler';
import { cardListToggleInteraction } from '../utils/performance-analytics';

export const setCardListToggleStart = () => {
	traceUFOPress('backlog-card-list-toggle');
	cardListToggleInteraction.start();
};

export const setCardListToggleFinish = () => {
	cardListToggleInteraction.stop({
		customData: { ...getNormalisedPerformanceFFs() },
	});
};

export const scheduleCardListToggleFinish = () => {
	scheduleAfterRender(() => {
		setCardListToggleFinish();
	});
};
